<template>
    <div v-if="!loading" class="request-pad">
        <div class="request-pad--id">
            R-{{ request.request_id }}<br/>
        </div>
        <div class="request-pad--status">
            <!--<div>status</div>-->
            <b-badge :variant="status_variant">
                {{ request.request_status }}
            </b-badge>
            <div v-if="is_admin">
                banconista <b>{{request.banconiste_id}}</b>
            </div>
        </div>
        <div class="request-pad--info">
            <div class="request-pad--info--line">
              creato {{request.created_at | moment("DD-MM-YYYY HH:mm") }}
            </div>
            <div class="request-pad--info--line">
                <strong>{{ user_request['request-customer'].firstname }} {{ user_request['request-customer'].lastname }}</strong>
                - <strong>{{ user_request['request-customer'].company }}</strong>
            </div>
            <div class="request-pad--info--line">
                <strong><a :href="'mailto:'+user_request['request-customer'].email">{{ user_request['request-customer'].email }}</a></strong>
                &nbsp;&nbsp;
                <strong><a :href="'phone:'+user_request['request-customer'].phone">{{ user_request['request-customer'].phone }}</a></strong>
            </div>
            <div class="request-pad--info--line" v-if="user_request['request-customer']">
                <b-button size="sm" variant="info" @click="() => { this.$bvModal.show('modal-request-'+request.request_id) }">
                    Vedi richiesta utente
                </b-button>
                <b-modal :id="'modal-request-'+request.request_id" title="Richiesta utente" size="lg">
                    <user-request :user_request="user_request" :pax="{}"/>
                </b-modal>
                <b-badge class="ml-1" v-if="user_request['request-budget']" variant="info" title="budget indicato per il viaggio">{{ user_request['request-budget'].budget }} €</b-badge>
                <b-badge class="ml-1" v-if="user_request['request-customer'].availability" variant="success" title="credito welfare attualmente disponibile">{{ user_request['request-customer'].availability }} €</b-badge>
            </div>
            <div class="request-pad--info--line" v-if="request.quote_title">
                Proposta: <b>{{ request.quote_title}}</b>
            </div>
            <div class="request-pad--info--line" v-if="request.product_code">
                travel id {{ request.travel_id }} (<strong>{{ request.product_code }}</strong>)<br/>
            </div>
            <div class="request-pad--info--line" v-if="request.updated_at != request.created_at">
              ultima modifica {{request.updated_at | moment("DD-MM-YYYY HH:mm") }}<br/>
              {{request.banconista_display_name}}
            </div>
        </div>
    </div>
</template>
<script>
    import UserRequest from '@/components/blocks/user-request'
    export default {
        name: 'request-pad',
        components: {
          'user-request': UserRequest,
        },
        props: {
            request: Object,
            is_admin: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                loading: true,
                user_request: {},
            }
        },
        computed: {
        },
        created()
        {
        },
        mounted() {
            this.user_request = JSON.parse(this.request.user_request)
            this.loading = false
            
            this.status_variant = 'info' // created|assigned|inReview e published
            if(this.request.request_status == 'assigned') this.status_variant = 'warning'
            if(this.request.request_status == 'declined') this.status_variant = 'danger'
            if(this.request.request_status == 'accepted') this.status_variant = 'danger'
            if(this.request.request_status == 'inReview') this.status_variant = 'success'
            if(this.request.request_status == 'published') this.status_variant = 'success'
            if(this.request.request_status == 'booked') this.status_variant = 'success'
        },
        methods:{
        },
    }
</script>

<style lang="scss">
// vedi request-pad.scss
</style>
